



















import ContactUsLink from '@front-app/components/ContactUsLink.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { ContactUsLink },
	props: {
		suggestRefresh: Boolean,
	},
});
